import { Component, AfterViewInit, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Router, ActivatedRoute, Params } from '@angular/router';

@Component({
    // moduleId: __moduleName,
    selector: 'error-404',
    templateUrl: '404.component.html'
})

export class Error404Component implements OnInit {
    navigateUrl: string = '/request-appointment';
    public title: string = 'Page not found';

    constructor(private router: Router, private _titleService: Title) {
        this._titleService.setTitle(this.title);
    }


    ngOnInit() {
        console.log('Error404Component - Init');
    }

    goToHomePage() {
        this.router.navigate([this.navigateUrl]);
    }


}



// WEBPACK FOOTER //
// D:/TMB/TMB/MYTMB.UI/src/app/pages/error/404.component.ts